<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { Role } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import RoleTabs from './RoleTabs.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        role: Role;
    }>();

    const form = useForm({
        name: props.role.name,
        display_name: props.role.display_name,
        description: props.role.description,
        is_client: props.role.is_client,
        permission_ids: props.role.permissions.map((permission) => permission.id),
        role_company_ids: props.role.company.map((company) => company.id),
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.roles.update', role.id)"
        method="patch"
        :query-key="[QueryKey.ROLES]"
        title="roles.edit"
        modal-size="sm:max-w-3xl"
    >
        <RoleTabs :form="form" />
    </DialogForm>
</template>
